// Packages
import { useState, useEffect } from "react";
import {
  Link,
  useParams,
  useLocation,
  Redirect,
  useHistory,
} from "react-router-dom";
import PropTypes from "prop-types";
import { getFromLocalStorage } from "../../utils/webStorage";
import successimg from "../../assets/images/successimg.png";
// Material Ui
import { CircularProgress, Typography } from "@material-ui/core";
import MaterialTable from "material-table";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FaTimes, FaPen, FaTrash } from "react-icons/fa";

import moment from "moment";
// Styles
import "../superAdmin/superAdmin.css";

// Views
import SchoolAdminDashboard from "../schoolAdminPortal/schoolAdminDashboard";
import menuthree from "../../assets/images/menuthree.png";
import ErrorMessage from "../../Common/ErrorMessage";

// Services
import userService from "../../services/user.service";
import { useSelector } from "react-redux";
import PageNotFound from "../../routes/PageNotFound";
import { userRoles } from "../../utils/constant";
import { DataGrid, GridColDef } from "@mui/x-data-grid";

import EventAction from "../../Common/EventAction";
import Paper from "@mui/material/Paper";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  typography: {
    padding: theme.spacing(2),
  },
}));

function tConvert(time) {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    time = time.slice(1);
    time[5] = +time[0] < 12 ? "AM" : "PM";
    time[0] = +time[0] % 12 || 12;
  }
  let timeformat = time.join("");
  if (timeformat.length == 10) {
    timeformat = timeformat.slice(0, 5) + " " + timeformat.slice(8, 10);
  } else {
    timeformat = timeformat.slice(0, 4) + " " + timeformat.slice(7, 9);
  }
  return timeformat;
}

function SchoolEvents() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [schoolData, setSchoolData] = useState();
  const [pastEventData, setPastEventData] = useState([]);
  const [opens, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [popSuccess, setSuccessPopDelete] = useState(false);
  const [schoolName, setSchoolName] = useState("");
  const [tabValue, setTabValue] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [zeroFlag, setZeroFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedRecord, setSearchedRecord] = useState(false);
  const [pastEventQuery, setPastEventQuery] = useState("");
  const [searchedPastRecord, setSearchedPastRecord] = useState(false);
  const [noRecordFound, setNoRecordFound] = useState(false);
  const [noRecordFoundC, setNoRecordFoundC] = useState(false);
  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 0,
    pageSize: 10,
  });
  const [currentPageState, setCurrentPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 0,
    pageSize: 10,
  });

  const history = useHistory();
  const userRole = useSelector((state) => state.loggedInUser.role);

  const eventone = document.getElementById("Event");
  if (eventone) {
    eventone.classList.add("btnActive");
  }

  const queryParams = new URLSearchParams(window.location.search);
  const temptab = parseInt(queryParams.get("pastEvent"));

  useEffect(() => {
    setSubmitting(true);
    if (temptab !== null) {
      setTabValue(temptab);
    }
    var schoolId = getFromLocalStorage("schoolId");
    const schoolName = getFromLocalStorage("schoolName");
    setSchoolId(schoolId);
    setSchoolName(schoolName);
    //---------upcoming events-----------------------
    userService
      .getUpcomingEventListing(schoolId)
      .then((response) => {
        if (response.data.status == true) {
          let arr = [];
          arr = response.data.data.events;
          if (arr.length === 0) {
            setZeroFlag(true);
          }
          setSchoolData(arr);
          setSubmitting(false);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    //------------------------past event-------------------
    userService
      .getPastEventListing(schoolId)
      .then((response) => {
        if (response.data.status == true) {
          let arr = [];
          arr = response.data.data.events;
          setPastEventData(arr);
          setSubmitting(false);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    getCurrentEventsByPage(currentPageState.page, currentPageState.pageSize);
    getPastEventsByPage(pageState.page, pageState.pageSize);
  }, []);

  const getPastEventsByPage = (page, size) => {
    const schoolId = getFromLocalStorage("schoolId");
    setPageState({ ...pageState, isLoading: true });
    userService.getPastEventByPage(schoolId, page, size).then((res) => {
      setPageState({
        ...pageState,
        data: res.data.data.events,
        isLoading: false,
        total: res.data.data.total,
        page: page,
      });
      setLoading(false);
    });
  };
  const searchPastEvent = (query, page, size) => {
    let schoolId = getFromLocalStorage("schoolId");

    setPageState((old) => ({
      ...old,
      isLoading: true,
    }));
    setPastEventQuery(query);
    if (!searchedRecord) {
      setSearchedPastRecord(true);
    }
    userService.searchPastEvent(query, schoolId, page, size).then((res) => {
      setPageState((old) => ({
        ...old,
        data: res.data.data.events,
        isLoading: false,
        total: res.data.data.total,
        page: page,
      }));
      setNoRecordFound(res.data.data.events.length == 0 ? true : false);
    });
  };

  const getCurrentEventsByPage = (page, size) => {
    const schoolId = getFromLocalStorage("schoolId");
    setCurrentPageState({ ...currentPageState, isLoading: true });
    userService.getCurrentEventByPage(schoolId, page, size).then((res) => {
      setCurrentPageState({
        ...currentPageState,
        data: res.data.data.events,
        isLoading: false,
        total: res.data.data.total,
        page: page,
      });
      setLoading(false);
    });
  };
  const searchUpcommingEvent = (query, page, size) => {
    let schoolId = getFromLocalStorage("schoolId");
    setCurrentPageState((old) => ({
      ...old,
      isLoading: true,
    }));
    setSearchQuery(query);
    if (!searchedRecord) {
      setSearchedRecord(true);
    }
    userService.searchCurrentEvent(query, schoolId, page, size).then((res) => {
      setCurrentPageState((old) => ({
        ...old,
        data: res.data.data.events,
        isLoading: false,
        total: res.data.data.total,
        page: page,
      }));
      setNoRecordFoundC(res.data.data.events.length == 0 ? true : false);
    });
  };

  const currenttableColumns = [
    {
      headerName: "EVENT NAME",
      field: "eventName",
      headerClassName: "table-header2 bold",
      width: 200,
      renderCell: (params) => (
        <div
          className="link-blue d-flex-align-cent height-70 oflow-hidden noWrap width-100"
          key={params.row.id}
        >
          <p>{params.row.eventName}</p>
        </div>
      ),
    },

    {
      headerName: "EVENT DATE",
      field: "eventDate",
      headerClassName: "table-header bold",
      width: 150,
      type: "date",
      dateSetting: { locale: "en-US" },
      renderCell: (params) => (
        <div className="link-blue text-center pl-1" key={params.row.id}>
          {params.row.eventDate}
        </div>
      ),
    },
    {
      headerName: "EVENT TIME",
      field: "eventTime",
      headerClassName: "table-header bold",
      type: "datetime-local",
      width: 150,
      renderCell: (params) => (
        <div className="pl-1">
          <label>{tConvert(params.row.eventTime)}</label>
        </div>
      ),
    },

    {
      headerName: "EVENT TYPE",
      field: "eventType",
      headerClassName: "table-header bold",
      width: 130,
      renderCell: (params) => (
        <div className="pl-1">
          <label>{params.row.eventType}</label>
        </div>
      ),
    },
    {
      headerName: "EVENT LOCATION ",
      field: "location",
      headerClassName: "table-header bold",
      width: 230,
      renderCell: (params) => (
        <div className="pl-1">
          <span>
            {params.row.location.slice(0, 18)}
            {params.row.location.length >= 18 ? "..." : ""}
          </span>
        </div>
      ),
    },
    {
      headerName: "TEAMS",
      field: "team",
      headerClassName: "table-header bold",
      width: 250,
      renderCell: (params) => (
        <div className="">
          {params.row.school.schoolName.slice(0, 10)}...
          <span className="link-blue px-1">Vs</span>
          {params.row.school2Name.slice(0, 10)}...
        </div>
      ),
    },
    {
      width: 150,
      headerClassName: "table-header",
      cellClassName: "mng-z-index2 bold",
      align: "center",
      renderCell: (params) => (
        <div
          className="dropdown d-flex-center pl-1"
          onClick={(event) => event.stopPropagation()}
        >
          <EventAction
            rowData={params.row}
            openDialog={openDialog}
            navigationLink="editevent"
            status="currentevent"
          />
        </div>
      ),
    },
  ];
  const tableColumns = [
    {
      headerName: "EVENT NAME",
      field: "eventName",
      headerClassName: "table-header2 bold",
      width: 200,
      renderCell: (params) => (
        <div
          className="link-blue d-flex-align-cent height-70 oflow-hidden noWrap width-100"
          key={params.row.id}
        >
          <p>{params.row.eventName}</p>
        </div>
      ),
    },

    {
      headerName: "EVENT DATE",
      field: "eventDate",
      headerClassName: "table-header bold",
      width: 150,
      type: "date",
      dateSetting: { locale: "en-US" },
      renderCell: (params) => (
        <div className="link-blue pl-1" key={params.row.id}>
          <span>{params.row.eventDate}</span>
        </div>
      ),
    },
    {
      headerName: "EVENT TIME",
      field: "eventTime",
      headerClassName: "table-header bold",
      type: "datetime-local",
      width: 150,
      renderCell: (params) => (
        <div className="pl-1">
          <span>{tConvert(params.row.eventTime)}</span>
        </div>
      ),
    },

    {
      headerName: "EVENT TYPE",
      headerClassName: "table-header bold",
      field: "eventType",
      width: 130,
      renderCell: (params) => (
        <div className="pl-1">
          <span>{params.row.eventType}</span>
        </div>
      ),
    },
    {
      headerName: "EVENT LOCATION ",
      field: "location",
      headerClassName: "table-header bold",
      width: 230,
      renderCell: (params) => (
        <div className="pl-1">
          <span>
            {params.row.location.slice(0, 18)}
            {params.row.location.length >= 18 ? "..." : ""}
          </span>
        </div>
      ),
    },
    {
      headerName: "TEAMS",
      field: "team",
      headerClassName: "table-header bold",
      width: 250,
      renderCell: (params) => (
        <div className="pl-1">
          {params.row.school.schoolName.slice(0, 10)}...
          <span className="link-blue px-1">Vs</span>
          {params.row.school2Name.slice(0, 10)}...
        </div>
      ),
    },
    {
      width: 150,
      headerClassName: "table-header bold",
      cellClassName: "mng-z-index2",
      align: "center",
      renderCell: (params) => (
        <div
          className="dropdown d-flex-center "
          onClick={(event) => event.stopPropagation()}
        >
          {params.row.isMediaPresent == false && (
            <EventAction
              rowData={params.row}
              openDialog={openDialog}
              status="pastevent"
            />
          )}
        </div>
      ),
    },
  ];
  const handleChange = (event, newValue) => {
    if (tabValue == "") {
      setValue(newValue);
    } else {
      setTabValue(newValue);
    }
  };

  const openDialog = (id) => {
    setOpen(true);
    setDeleteId(id);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const ConfirmcloseDialog = () => {
    userService.deleteVideoEvent(deleteId).then((res) => {
      setOpen(false);
      callAfterDelete();
    });
  };

  const callAfterDelete = () => {
    userService
      .getUpcomingEventListing(schoolId)
      .then((response) => {
        if (response.data.status == true) {
          let arr = [];
          arr = response.data.data.events;
          setSchoolData(arr);
          openDialogRemoved();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    //------------------------past event-------------------
    userService
      .getPastEventListing(schoolId)
      .then((response) => {
        if (response.data.status == true) {
          let arr = [];
          arr = response.data.data.events;
          setPastEventData(arr);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const openDialogRemoved = () => {
    setSuccessPopDelete(true);
  };
  const closeDialogRemoved = () => {
    setSuccessPopDelete(false);
  };

  return (
    <div>
      {userRole !== userRoles.ROLE_ATHLETE ? (
        <div className="dynamic-height">
          <div className={submitting ? "gray-out" : ""}>
            <SchoolAdminDashboard />
            <div className="content-layout p-0">
              <div className="">
                <div className="col-lg-12 col-md-12 col-sm-12"></div>
                <div className={classes.root} id="tabs">
                  <div className="row" id="mobTop-5">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mng-header mng-padding">
                      <Tabs
                        className="tab-nm"
                        value={tabValue ? tabValue : value}
                        onChange={handleChange}
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                      >
                        <Tab
                          label="Upcoming Events"
                          {...a11yProps(0)}
                          style={{ minWidth: "10%" }}
                        />
                        <Tab label="Past Events" {...a11yProps(1)} />
                      </Tabs>
                      <Link
                        to={{
                          pathname: "/createevents",
                          state: { path: "/schoolevents" },
                        }}
                      >
                        <button className="addBtnn2 mng-padding  mg-right-15">
                          <AddIcon className="mr-2 addIconSc " />
                          {""}Create Event
                        </button>
                      </Link>
                    </div>
                  </div>
                  <TabPanel value={tabValue ? tabValue : value} index={0}>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 dynamic-height">
                      {!loading &&
                        (currentPageState.data.length !== 0 ||
                          noRecordFoundC) && (
                          <div className="grid-width">
                            <Paper className="pad-top-20">
                              <div className="input-container d-flex-align-right mg-bottom-10">
                                <input
                                  className="custom-search-bar"
                                  value={searchQuery}
                                  onChange={(e) => {
                                    if (
                                      e.target.value == "" &&
                                      searchedRecord
                                    ) {
                                      getCurrentEventsByPage(
                                        currentPageState.page,
                                        currentPageState.pageSize
                                      );
                                    }
                                    setSearchQuery(e.target.value);
                                  }}
                                  type="search"
                                  id="search_input"
                                  placeholder="Search"
                                />
                                {searchQuery && (
                                  <p
                                    className="cancel-Search-icon2 fs-14"
                                    onClick={() =>
                                      searchUpcommingEvent(searchQuery, 0, 10)
                                    }
                                  >
                                    Search
                                  </p>
                                )}
                              </div>

                              <DataGrid
                                rows={currentPageState.data}
                                rowCount={currentPageState.total}
                                loading={currentPageState.isLoading}
                                pagination
                                page={currentPageState.page}
                                columns={currenttableColumns}
                                pageSize={currentPageState.pageSize}
                                rowsPerPageOptions={[10]}
                                paginationMode="server"
                                onPageChange={(newPage) => {
                                  if (searchQuery == "") {
                                    getCurrentEventsByPage(newPage, 10);
                                  } else {
                                    searchUpcommingEvent(
                                      searchQuery,
                                      newPage,
                                      10
                                    );
                                  }
                                  setCurrentPageState((previous) => ({
                                    ...previous,
                                    page: newPage,
                                  }));
                                }}
                                onPageSizeChange={(newPageSize) =>
                                  setCurrentPageState((previous) => ({
                                    ...previous,
                                    pageSize: newPageSize,
                                  }))
                                }
                                sx={{
                                  color: "black",
                                  fontFamily: "Rajdhani-SemiBold",
                                  fontSize: "18px",
                                  backgroundColor: "white",
                                  borderRadius: "12px",
                                }}
                                onCellClick={(params) => {
                                  history.push(`/editevent/${params.row.id}`);
                                }}
                                autoHeight
                                getRowHeight={() => "auto"}
                              />
                            </Paper>
                          </div>
                        )}
                      {currentPageState.data.length === 0 &&
                        !loading &&
                        !noRecordFoundC && <ErrorMessage />}
                    </div>
                  </TabPanel>
                  <TabPanel value={tabValue ? tabValue : value} index={1}>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 dynamic-height">
                      {!loading &&
                        (pageState.data.length !== 0 || noRecordFound) && (
                          <div className="grid-width">
                            <Paper className="pad-top-20">
                              <div className="input-container d-flex-align-right mg-bottom-10">
                                <input
                                  className="custom-search-bar"
                                  value={pastEventQuery}
                                  onChange={(e) => {
                                    if (
                                      e.target.value == "" &&
                                      searchedPastRecord
                                    ) {
                                      getPastEventsByPage(
                                        pageState.page,
                                        pageState.pageSize
                                      );
                                    }
                                    setPastEventQuery(e.target.value);
                                  }}
                                  type="search"
                                  id="search_input"
                                  placeholder="Search"
                                />
                                {pastEventQuery && (
                                  <p
                                    className="cancel-Search-icon2 fs-14"
                                    onClick={() =>
                                      searchPastEvent(pastEventQuery, 0, 10)
                                    }
                                  >
                                    Search
                                  </p>
                                )}
                              </div>
                              <DataGrid
                                rows={pageState.data}
                                rowCount={pageState.total}
                                loading={pageState.isLoading}
                                pagination
                                page={pageState.page}
                                columns={tableColumns}
                                pageSize={pageState.pageSize}
                                rowsPerPageOptions={[10]}
                                paginationMode="server"
                                onPageChange={(newPage) => {
                                  if (pastEventQuery == "") {
                                    getPastEventsByPage(newPage, 10);
                                  } else {
                                    searchPastEvent(
                                      pastEventQuery,
                                      newPage,
                                      10
                                    );
                                  }
                                  setPageState((previous) => ({
                                    ...previous,
                                    page: newPage,
                                  }));
                                }}
                                onPageSizeChange={(newPageSize) =>
                                  setPageState((previous) => ({
                                    ...previous,
                                    pageSize: newPageSize,
                                  }))
                                }
                                sx={{
                                  color: "black",
                                  fontFamily: "Rajdhani-SemiBold",
                                  fontSize: "18px",
                                  backgroundColor: "white",
                                  borderRadius: "12px",
                                }}
                                onCellClick={(params) => {
                                  history.push(
                                    `/editcompletedevents/${params.row.id}`
                                  );
                                }}
                                autoHeight
                                getRowHeight={() => "auto"}
                              />
                            </Paper>
                          </div>
                        )}
                      {pageState.data.length === 0 &&
                        !loading &&
                        !noRecordFound && <ErrorMessage />}
                    </div>
                    <div className="clear20"></div>
                  </TabPanel>
                </div>
                <Dialog id="dialogBox" open={opens} onClose={closeDialog}>
                  <DialogTitle>
                    <div className="row">
                      <div className="col-1 text-right ml-auto ">
                        <FaTimes
                          onClick={closeDialog}
                          className="crossview cp"
                        />
                      </div>
                    </div>
                  </DialogTitle>
                  <DialogContent>
                    <div className="clear10"></div>
                    <div className="row">
                      <div className="col-12 text-center">
                        <p className="fs-20 semi-bold text-center mb-4">
                          Are you sure
                          <br />
                          you want to remove the record?
                        </p>
                      </div>
                      <div className="col-5 col-md-3 col-lg-3 ml-auto text-center">
                        <button
                          type="button"
                          class="cancelbtn canBtn"
                          onClick={closeDialog}
                        >
                          No
                        </button>
                      </div>
                      <div className="col-5 col-md-3 col-lg-3 mr-auto text-center ">
                        <button
                          type="button"
                          class="yes-btn delBtn"
                          onClick={ConfirmcloseDialog}
                        >
                          Yes, Remove
                        </button>
                      </div>
                    </div>
                    <div className="clear10"></div>
                    <div className="clear10"></div>
                  </DialogContent>
                </Dialog>

                <Dialog
                  id="dialogBoxRemove"
                  open={popSuccess}
                  onClose={closeDialogRemoved}
                >
                  <DialogTitle>
                    <div className="row">
                      <div className="col-1 text-right ml-auto">
                        <FaTimes
                          onClick={closeDialogRemoved}
                          className="crossview cp"
                        />
                      </div>
                    </div>
                  </DialogTitle>
                  <DialogContent>
                    <div className="clear10"></div>
                    <div className="row">
                      <div className="col-12 text-center">
                        <img
                          src={successimg}
                          alt="success"
                          className="successimg-new"
                        ></img>
                        <p className="fs-20 semi-bold text-center">
                          Event Removed Successfully!
                        </p>
                        <div className="clear10"></div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                        <button
                          type="button"
                          class="donebtn canBtn"
                          onClick={closeDialogRemoved}
                        >
                          DONE
                        </button>
                      </div>
                    </div>

                    <div className="clear10"></div>

                    <div className="clear10"></div>
                  </DialogContent>
                </Dialog>
                {/* end */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <PageNotFoundPage />
      )}

      {loading && (
        <CircularProgress className="circle-mark" color="secondary" />
      )}
    </div>
  );
}

export default SchoolEvents;
